import {
  CardHeader,
  CardContent,
  CardActions,
  Avatar,
  IconButton,
  Typography,
  Collapse,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
} from "@mui/material";
import { CardContainer, ExpandMoreButton, FavoriteButton } from "./styles";
import {
  Delete,
  ExpandMore,
  Favorite,
  Payment,
  Receipt,
} from "@mui/icons-material";

import { useReceiptsData } from "../../../Hooks";

import { cnpjMask, cpfMask } from "../../../Utils";
import { TagContainer } from "../TagContainer";
import { useEffect, useState } from "react";

export const ContactCard = ({ contact, refreshContacts, testFavs }) => {
  const [expanded, setExpanded] = useState(false);
  const [testingFavs, setTestingFavs] = useState(contact.favorite);
  const {
    state: contactData,
    handlePUT: fetchReceiptsPUT,
    loading,
  } = useReceiptsData();
  const handleFavoriteCard = () => {
    /* const args = {
      id: contact.id,
      body: {
        ...contact,
        favorite: !contact.favorite,
      },
    };
    fetchReceiptsPUT(args);
    refreshContacts(); */
    testFavs(contact);
    setTestingFavs(!testingFavs);
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <CardContainer>
      <CardHeader
        avatar={
          <Avatar>
            {!!contact.name.split(" ")[0] && !!contact.name.split(" ")[1]
              ? contact.name.split(" ")[0].substring(0, 1) +
                contact.name.split(" ")[1].substring(0, 1)
              : contact.name.split(" ")[0].substring(0, 1)}
          </Avatar>
        }
        title={contact.name}
        subheader={
          contact.document?.length > 11
            ? cnpjMask(contact.document)
            : contact.document !== undefined
            ? cpfMask(contact.document)
            : ""
        }
      />

      <CardContent>
        <TagContainer />
        <Typography paragraph>Contas</Typography>
        {contact.banks && (
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Banco</TableCell>
                <TableCell align="left">Conta</TableCell>
                <TableCell align="left">Agência</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contact.banks?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="left">{row.BankName}</TableCell>
                  <TableCell align="left">{row.bankCode}</TableCell>
                  <TableCell align="left">{row.branch}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
      <CardActions>
        <FavoriteButton
          favorite={testingFavs}
          title="Adicionar à favoritos"
          onClick={handleFavoriteCard}
        >
          <Favorite />
        </FavoriteButton>
        <IconButton title="Transferir" size="large">
          <Payment />
        </IconButton>
        <IconButton title="Ver movimentações entre contas" size="large">
          <Receipt />
        </IconButton>

        <IconButton title="Excluir contato" size="large">
          <Delete />
        </IconButton>
        <ExpandMoreButton
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="Mostrar últimas movimentações"
          title="Mostrar últimas movimentações"
        >
          <ExpandMore />
        </ExpandMoreButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Últimas transações</Typography>
          {contact.lastOperations && (
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Pagador</TableCell>
                  <TableCell align="left">Valor</TableCell>
                  <TableCell align="left">Data</TableCell>
                  <TableCell align="left">Tipo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contact.lastOperations?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.payer}</TableCell>
                    <TableCell align="left">
                      {/* {convertToCents(row.amount)} */}
                    </TableCell>
                    <TableCell align="left">{row.date}</TableCell>
                    <TableCell align="left">{row.type}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Collapse>
    </CardContainer>
  );
};
